import React, { ReactNode } from 'react';
import { ToastStore } from './Toasts';
import { DialogStore } from './Dialogs';

export function AlertContainer({children}:{children:ReactNode}){
    return <ToastStore>
        <DialogStore>{children}</DialogStore>
    </ToastStore>
}

